import { Container } from "component_library/components/react/FlexDiv"
import React from "react"
import styled from "styled-components"
import Text from "component_library/components/react/Text"
import { theme } from "component_library/styles/theme"
import Badge from "component_library/components/react/Badge"

const Dot = styled.span`
  background-color: ${({ theme }) => theme.red_500};
  height: 8px;
  width: 8px;
  border-radius: 50%;
  position: absolute;
  top: -5px;
  right: -5px;
  box-sizing: content-box;
  border: 2px solid ${({ theme }) => theme.blue_900};
`

interface NavigationInsideLinkProps {
  isActive: boolean
  Icon: React.FC
  text: string
  labelBadge?: string
  smallBadge?: boolean
}
const NavigationInsideLink = ({
  isActive,
  Icon,
  text,
  labelBadge,
  smallBadge,
}: NavigationInsideLinkProps): JSX.Element => {
  return (
    <Container paddingX={4} paddingY={3} gap={text ? 3 : 0} align="center">
      <Container width="auto">
        <Icon fill={isActive ? "white" : theme.gray_500} />
        {labelBadge && smallBadge && <Dot />}
      </Container>
      <Text as={Container} textType="body" fontColor="white" flex={1}>
        {text}
      </Text>
      {labelBadge && !smallBadge && (
        <Badge
          radius="large"
          fontSize="10px"
          bgColor="red_500"
          paddingX={2}
          paddingY={1}
          fontFamily="fontBody"
        >
          {labelBadge}
        </Badge>
      )}
    </Container>
  )
}

export default NavigationInsideLink
